import React, {useContext, useEffect, useState} from "react";
import {Categories} from "../assets/categories";
import academicPersonnelPages from "../assets/academicPersonnelPages";
import departmentMapLinks from "../assets/departmentMapLinks";
import MenuBox from "../components/MenuBox";
import {Grid, Heading} from "@chakra-ui/react";
import departmentAnnouncements from "../assets/departmentAnnouncements";
import {motion} from "framer-motion";
import WaveBackground from "../assets/backgrounds/WaveBackground.svg";

const stagger = {
    inView: {
        transition: {
            staggerChildren: 0.1,
        },
    },
};

export default function HomePage() {
    const [categoriesListForSearch, setCategoriesListForSearch] = useState(Categories);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            id="main-grid"
            alignItems="start"
            justifyContent="center"
            gap={"3rem"}
            h={{sm: "100%"}}
            px={{sm: "1rem", lg: "3rem"}}
            py={{sm: "0.5rem", lg: "3rem"}}
            minHeight={"100vh"}
            style={{
                backgroundImage: `url(${WaveBackground})`,
                backgroundPosition: "bottom",
                backgroundRepeat: "none",
                backgroundSize: "cover"
            }}
            overflow={"auto"}
        >
            <Grid
                as={motion.section}
                initial="initial"
                animate="inView"
                variants={stagger}
                className="home-grid"
                marginTop="20px"
                gap={{sm: 2, md: 3, lg: 4, xl: 5, "2xl": 6, "3xl": 7}}
                templateColumns={{
                    sm: "repeat(3, 1fr)",
                    md: "repeat(3, minmax(0, 1fr))",
                    xl: "repeat(5, calc((var(--available-width) - 5rem) / 5))",
                    xxl: "repeat(5, calc((var(--available-width) / 1.5) / 5))",
                    "2xl": "repeat(5, calc((var(--available-width) / 1.75) / 5))",
                    "3xl": "repeat(5, calc((2*var(--available-width)/3) / 5))",
                }}
            >
                {categoriesListForSearch.length === 0 ? (
                    <Heading gridColumnStart={1}
                             gridColumnEnd={3}
                             fontSize={{sm: 11.95, md: 16, lg: 26, xl: 28}}
                             w="100%"
                             fontWeight={500}>
                        Η αναζήτηση δεν επέστρεψε αποτελέσματα.
                    </Heading>
                ) : null}
                {categoriesListForSearch.map((category) => (
                    <MenuBox category={category}
                             key={category.title}/>
                ))}
            </Grid>
        </Grid>
    );
}
